import React from "react";
import RetailerIdAndName from "../Components/RetailerIdAndName";
import {getRetailerName, loadRetailerMap} from "../../utils/localCache/retailerMapCache";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import {INDEX_FIELD,} from "../Components/ReactTable/common_custom_columns";
import {
    EditFormDropdownInputField,
    EditFormNumberInputField,
    EditFormTextInputField
} from "../Components/ReactTable/EditRecordForm";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import {getStringParamOrDefault} from "../../utils/urlBuilder";
import {queryParamFilterReactTable7} from "../../utils/QueryParamFilter";
import {toastError} from "../../utils/toast";
import {toast} from "react-toastify";

export const retailerQueryStringKey = 'retailer';
export const retailerColumnId = 'retailerIdName';

function getFilters() {
    return {
        columnFilters: [{
            id: retailerColumnId,
            value: getStringParamOrDefault(retailerQueryStringKey, '')
        }]
    }
}

const storesGqlQuery = (retailerId) => `
        query stores {
            stores(retailerId: ${retailerId}) {
                storeId
            }
        }`;

function RetailerService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/retailers/`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const onRowEditWrapped = async (...args) => {
        await onRowEditConfirmed(...args);
        await loadRetailerMap();
    };

    async function checkHasNoStores(retailerId) {
        let result = await makeApolloClientCall(storesGqlQuery(retailerId));
        console.log(result);
        return result["stores"].length <= 0;
    }

    const onRowDeleteWrapped = async (...args) => {
        const retailerId = args[0].retailerId;
        if (await checkHasNoStores(retailerId)) {
            await onRowDeleteConfirmed(...args);
            await loadRetailerMap();
        } else {
            toastError(toast, `There are still stores linked to this retailer and therefore can not be deleted. Please remove the stores and try again!`)
        }
    }
    const rollUpDayOfWeek = [
        {value: "SUNDAY", label: "SUNDAY"},
        {value: "MONDAY", label: "MONDAY"},
        {value: "TUESDAY", label: "TUESDAY"},
        {value: "WEDNESDAY", label: "WEDNESDAY"},
        {value: "THURSDAY", label: "THURSDAY"},
        {value: "FRIDAY", label: "FRIDAY"},
        {value: "SATURDAY", label: "SATURDAY"}
    ];
    const retailerType = [{value: "CHAIN", label: "CHAIN"}, {value: "INDEPENDENT", label: "INDEPENDENT"}];

    const customColumns = [
        {
            header: "Retailer",
            id: "retailerIdName",
            filterable: true,
            accessorKey: "retailerId",
            size: 200,
            cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,
            filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.retailerId} ${getRetailerName(row.original.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase())),
            filter: queryParamFilterReactTable7(retailerQueryStringKey)
        },
        {
            header: "Retail Tag",
            accessorKey: "retailTag"
        },
        {
            header: "Retailer Type",
            accessorKey: "retailerType"
        },
        {
            header: "Roll Up Day Of Week",
            accessorKey: "rollUpDayOfWeek"
        },
        {
            header: "Scv Growth Factor",
            accessorKey: "scvGrowthFactor"
        },
        {
            header: "Svc Acv Inflation Factor",
            accessorKey: "svcAcvInflationFactor"
        }
    ];

    const filters = getFilters();

    return (
        <Page name={"All Retailers"}
              breadCrumbs={<Breadcrumbs items={[{label: "Management"}, {label: "Retailers"}, {label: "All Retailers"}]}/>}>
            <LoadingWrapper loading={loading}>
                <EditableReactTableV2
                    key={JSON.stringify(filters)}
                    filterable
                    data={data.data}
                    columns={customColumns}
                    initialState={{...filters, pagination: {pageSize: 25}, sorting: [{id: "retailerIdName", desc: false}]}}
                    editTable={[
                        INDEX_FIELD,
                        {
                            id: "retailChain",
                            Component: args => <EditFormTextInputField  {...args} isRequired label={"Retail Chain"}/>
                        },
                        {id: "retailTag", Component: args => <EditFormNumberInputField  {...args} disabled/>},
                        {
                            id: "retailerId",
                            Component: args => <EditFormNumberInputField  {...args} disabled label={"Retailer Id"}/>
                        },
                        {
                            id: "retailerType",
                            Component: args => <EditFormDropdownInputField  {...args} isRequired
                                                                            options={retailerType}/>
                        },
                        {
                            id: "rollUpDayOfWeek",
                            Component: args => <EditFormDropdownInputField  {...args} isRequired
                                                                            options={rollUpDayOfWeek}/>
                        },
                        {id: "scvGrowthFactor", Component: args => <EditFormNumberInputField  {...args}  />},
                        {id: "svcAcvInflationFactor", Component: args => <EditFormNumberInputField  {...args}  />},

                    ]}
                    onRowEditConfirmed={onRowEditWrapped}
                    onRowDeleteConfirmed={onRowDeleteWrapped}
                />
            </LoadingWrapper>
        </Page>
    );
}

export default RetailerService;
